module.exports = __webpack_public_path__ + "img/kv_pc.4393a36c.jpg";